const DEPRECATED_PROP_MESSAGES = {
    size: 'Use `size` prop instead.',
    width: 'Use `width` prop instead.',
    accessibleText: 'Use `accessibleText` prop instead.'
};

export { DEPRECATED_PROP_MESSAGES };
